export default "__VITE_PUBLIC_ASSET__32dc2b54__"